<div class="content">
  <div
    class="d-flex mb-2"
    style="align-items: center; justify-content: space-between"
  >
    <span>{{ "FAQ" | translate }}</span>
    <div class="btns">
      <div *ngIf="isEditMode; else editBtn">
        <button class="btn btn-sm btn-secondary" (click)="onCancel()">
          Cancel
        </button>
        <button class="btn btn-sm btn-primary" (click)="onSaveQuestion()">
          Save
        </button>
      </div>
      <ng-template #editBtn>
        <button class="btn btn-sm btn-secondary" (click)="onEditQuestion()">
          Edit
        </button>
        <button
          class="btn btn-sm btn-primary"
          (click)="onSaveAnswer()"
          *ngIf="answerChanged"
        >
          Save
        </button>
      </ng-template>
    </div>
  </div>
  <div class="list-group mb-3" cdkDropList (cdkDropListDropped)="drop($event)">
    <div
      class="list-group-item px-3"
      *ngFor="let d of data; let idx = index"
      cdkDrag
      [cdkDragDisabled]="!isEditMode"
    >
      <div class="dnd-placeholder" *cdkDragPlaceholder></div>
      <div class="row no-gutters">
        <div class="col-1">#{{ idx }}</div>
        <div
          *ngIf="!isEditMode; else questionForm"
          class="col"
          [class.d-flex]="d.question_display_template === 'inline'"
        >
          <p class="font-weight-bold">{{ d.question }}</p>
          <ng-container *ngIf="d.question_type === 'text'; else multipleAnswer">
            <p *ngIf="d.answer.length === 0; else textAnswer">
              {{ ".........." }}
            </p>
            <ng-template #textAnswer>
              <!-- <p>{{ d.answer[0] }}</p> -->
              <textarea
                type="text"
                class="form-control"
                [value]="d.answer[0]"
                [name]="'question-' + idx"
                (input)="onChangeAnswer($event)"
              ></textarea>
            </ng-template>
          </ng-container>
        </div>
        <div class="col-1 icon-btns" *ngIf="isEditMode">
          <a
            class="
              d-flex
              justify-content-center
              align-items-center
              text-secondary
              btn-tool
            "
          >
            <svg
              width="16px"
              cdkDragHandle
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
              ></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
            <span
              class="tooltip-text"
              style="margin-top: -3.5em; margin-left: 0em"
              >{{ "Drag" | titlecase }}</span
            ></a
          >
          <!-- <a class="d-flex justify-content-center align-items-center btn-tool"
            ><i class="icon-pencil"></i>
            <span
              class="tooltip-text"
              style="margin-top: -3.5em; margin-left: 0em"
              >{{ "Edit" | titlecase }}</span
            >
          </a> -->
          <a
            class="d-flex justify-content-center align-items-center btn-tool"
            style="color: crimson"
            (click)="deleteQuestion(idx)"
            ><i class="icon-delete"></i>
            <span
              class="tooltip-text"
              style="margin-top: -3.5em; margin-left: 0em"
              >Delete<br />Question</span
            ></a
          >
        </div>
      </div>
      <ng-template #multipleAnswer>
        <ng-container *ngIf="d.question_type === 'checkbox'; else radioAnswer">
          <div
            class="form-check"
            *ngFor="let a of d.answer_checkbox; let mi = index"
          >
            <input
              type="checkbox"
              class="form-check-input"
              [value]="mi"
              [checked]="d.answer.includes(mi.toString())"
              [name]="'question-' + idx"
              (change)="onChangeAnswer($event)"
            />
            <label class="form-check-label">{{ a }}</label>
          </div>
        </ng-container>
      </ng-template>
      <ng-template #radioAnswer>
        <div
          class="form-check"
          *ngFor="let a of d.answer_checkbox; let i = index"
        >
          <input
            type="radio"
            class="form-check-input"
            [value]="i"
            [checked]="d.answer.includes(i.toString())"
            [name]="'question-' + idx"
            (change)="onChangeAnswer($event)"
          />
          <label class="form-check-label" for="i">{{ a }}</label>
        </div>
      </ng-template>

      <ng-template #questionForm>
        <form class="col">
          <div class="form-group p-0">
            <label>Question</label>
            <textarea
              type="text"
              class="form-control"
              [value]="d.question"
              [name]="'question-' + idx"
              (input)="onChangeQuestion($event)"
            ></textarea>
          </div>
          <div class="form-group p-0">
            <label>Layout Type</label>
            <select
              class="form-control"
              [name]="'question_display_template-' + idx"
              (change)="onChangeQuestion($event)"
            >
              <option
                value="inline"
                [selected]="d.question_display_template === 'inline'"
              >
                Inline
              </option>
              <option
                value="row"
                [selected]="d.question_display_template === 'row'"
              >
                Row
              </option>
            </select>
          </div>
          <div class="form-group p-0">
            <label>Question Type</label>
            <select
              class="form-control"
              [name]="'question_type-' + idx"
              (change)="onChangeQuestion($event)"
            >
              <option value="text" [selected]="d.question_type === 'text'">
                Text
              </option>
              <option value="radio" [selected]="d.question_type === 'radio'">
                Single Answer
              </option>
              <option
                value="checkbox"
                [selected]="d.question_type === 'checkbox'"
              >
                Multiple Answer
              </option>
            </select>
          </div>
          <div
            class="form-group p-0 answer-selection"
            *ngIf="d.question_type !== 'text'"
          >
            <label>Answer Selection</label>
            <div
              class="d-flex align-items-center"
              *ngFor="let ac of d.answer_checkbox; let acIdx = index"
            >
              <input
                type="text"
                class="form-control flex-grow mr-2"
                [value]="ac"
                [name]="'answer_checbox-' + idx + '-' + acIdx"
                (change)="onChangeQuestion($event)"
              />
              <a
                (click)="addAnswerCheckbox(idx)"
                class="btn-tool mr-2"
                *ngIf="acIdx + 1 === d.answer_checkbox.length"
                ><i class="icon-create"></i
                ><span
                  class="tooltip-text"
                  style="margin-top: -3.5em; margin-left: 0em"
                  >{{ "Add" | titlecase }}</span
                ></a
              >
              <a
                class="btn-tool"
                style="color: crimson"
                (click)="removeAnswerCheckbox(idx, acIdx)"
                ><i class="icon-recycle"></i
                ><span
                  class="tooltip-text"
                  style="margin-top: -3.5em; margin-left: 0em"
                  >{{ "Delete" | titlecase }}</span
                ></a
              >
            </div>
          </div>
        </form>
      </ng-template>
    </div>
  </div>

  <!-- <div cdkDropList class="list-group" (cdkDropListDropped)="drop($event)">
    <div class="list-group-item px-3" *ngFor="let d of data" cdkDrag>
      <div class="dnd-placeholder" *cdkDragPlaceholder></div>
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <p>{{ d }}</p>
        </div>
        <div class="btns">
          <a class="btn btn-sm" cdkDragHandle>
            <svg
              width="24px"
              cdkDragHandle
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
              ></path>
              <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div> -->
  <button
    class="btn btn-primary btn-sm btn-block mt-3"
    *ngIf="isEditMode"
    (click)="addMoreQuestion()"
  >
    Add More
  </button>
</div>
